<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="ded"></a><a id="page_v"></a><em>For Ellen</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230617063_03_ded.vue?7067e81a